import { render, staticRenderFns } from "./OrderItemsContent.vue?vue&type=template&id=3e8c25d9&"
import script from "./OrderItemsContent.vue?vue&type=script&lang=js&"
export * from "./OrderItemsContent.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemsContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports